import { useCallback, useRef, useState } from 'react';

// need rework in formatMessage add writing trans keys into indexedDb
// read keys from indexedDb here
export const useTranslationStyles = () => {
  const [showTranslated, setShowTranslated] = useState(false);
  const mutationObserverRef = useRef<MutationObserver | null>(null);

  const applyTranslationStyles = useCallback(() => {
    const translatedElems = document.querySelectorAll('[data-trans]');
    for (const elem of translatedElems) {
      (elem as HTMLElement).style.color = 'darkblue';
    }
  }, []);

  const resetTranslationStyles = useCallback(() => {
    const translatedElems = document.querySelectorAll('[data-trans]');
    for (const elem of translatedElems) {
      (elem as HTMLElement).style.color = '';
    }
  }, []);

  const toggleTranslatedView = useCallback(() => {
    if (showTranslated) {
      // Turning off
      if (mutationObserverRef.current) {
        mutationObserverRef.current.disconnect();
        mutationObserverRef.current = null;
      }
      resetTranslationStyles();
      setShowTranslated(false);
    } else {
      // Turning on
      applyTranslationStyles();
      mutationObserverRef.current = new MutationObserver(
        applyTranslationStyles,
      );
      mutationObserverRef.current.observe(document.body, {
        childList: true,
        subtree: true,
      });
      setShowTranslated(true);
    }
  }, [showTranslated, applyTranslationStyles, resetTranslationStyles]);

  return {
    showTranslated,
    toggleTranslatedView,
  };
};
